import { NavItem } from "../../../components/nav/item";
import { NavSubItem } from "../../../components/nav/sub-item";
import { PERFORMANCE } from "icons";

export function PerformanceNavigations() {
    return (
        <NavItem title="Performance" icon={PERFORMANCE} url="/performance" matchExact={true}>
            <NavSubItem title="Overview" url="/performance/overview" />
            <NavSubItem title="Review" url="/performance/review" />
        </NavItem>
    );
}
